/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RewardFulfillmentClaimResponse
 */
export interface RewardFulfillmentClaimResponse {
    /**
     * 
     * @type {string}
     * @memberof RewardFulfillmentClaimResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof RewardFulfillmentClaimResponse
     */
    status: RewardFulfillmentClaimResponseStatusEnum;
}


/**
 * @export
 */
export const RewardFulfillmentClaimResponseStatusEnum = {
    PENDING: 'PENDING',
    SHIPPED: 'SHIPPED',
    CANCELLED: 'CANCELLED'
} as const;
export type RewardFulfillmentClaimResponseStatusEnum = typeof RewardFulfillmentClaimResponseStatusEnum[keyof typeof RewardFulfillmentClaimResponseStatusEnum];


/**
 * Check if a given object implements the RewardFulfillmentClaimResponse interface.
 */
export function instanceOfRewardFulfillmentClaimResponse(value: object): value is RewardFulfillmentClaimResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function RewardFulfillmentClaimResponseFromJSON(json: any): RewardFulfillmentClaimResponse {
    return RewardFulfillmentClaimResponseFromJSONTyped(json, false);
}

export function RewardFulfillmentClaimResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RewardFulfillmentClaimResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'status': json['status'],
    };
}

export function RewardFulfillmentClaimResponseToJSON(json: any): RewardFulfillmentClaimResponse {
    return RewardFulfillmentClaimResponseToJSONTyped(json, false);
}

export function RewardFulfillmentClaimResponseToJSONTyped(value?: RewardFulfillmentClaimResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'status': value['status'],
    };
}

